import script from "./DeliverySlipDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./DeliverySlipDetail.vue?vue&type=script&setup=true&lang=ts"

import "./DeliverySlipDetail.vue?vue&type=style&index=0&id=0705b90e&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0705b90e"]])

export default __exports__